import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const TaskTrashIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={11}
        height={12}
        viewBox="0 0 11 12"
        className="Icon task-trash"
        {...props}
    >
        <path
            fill="#A3A7AE"
            fillRule="evenodd"
            d="M4.496 0C3.676 0 3 .676 3 1.496V2H.5a.5.5 0 0 0 0 1H1v7.5c0 .824.676 1.5 1.5 1.5h6c.824 0 1.5-.676 1.5-1.5V3h.5a.5.5 0 0 0 0-1H8v-.504C8 .676 7.324 0 6.504 0H4.496zm0 1h2.008c.281 0 .496.215.496.496V2H4v-.504C4 1.215 4.215 1 4.496 1zM2 3h7v7.5c0 .281-.219.5-.5.5h-6a.494.494 0 0 1-.5-.5V3z"
        />
    </svg>
);
const Memo = memo(TaskTrashIcon);
export default Memo;
